module.exports = __webpack_public_path__ + "img/camara-circle.ddb725c5.svg";